'use client';
import { createContext } from 'react';

const WeddingDateContext = createContext();

function WeddingDateProvider({ children }) {
  const wedding_date = new Date('2024-11-29T19:30:00').getTime() - new Date().getTime();

  return <WeddingDateContext.Provider value={{ wedding_date }}>{children}</WeddingDateContext.Provider>;
}

export default WeddingDateContext;

export { WeddingDateProvider };
